import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Package, FolderOpen, ShoppingBag, IndianRupee, TrendingUp } from 'lucide-react';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    products: 0,
    categories: 0,
    orders: 0,
    revenue: 0
  });
  const [recentOrders, setRecentOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [statsRes, ordersRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/api/stats`),
        axios.get(`${BACKEND_URL}/api/orders?limit=5`)
      ]);
      setStats(statsRes.data);
      setRecentOrders(ordersRes.data);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    { label: 'Total Products', value: stats.products, icon: Package, color: '#D4AF37' },
    { label: 'Categories', value: stats.categories, icon: FolderOpen, color: '#34C759' },
    { label: 'Total Orders', value: stats.orders, icon: ShoppingBag, color: '#007AFF' },
    { label: 'Revenue', value: `₹${stats.revenue.toLocaleString()}`, icon: IndianRupee, color: '#FF3B30' },
  ];

  return (
    <div className="space-y-8" data-testid="admin-dashboard">
      <div>
        <h1 className="text-4xl font-light tracking-tighter text-white mb-2">Dashboard</h1>
        <p className="text-[#A3A3A3]">Welcome to Savistones Admin Panel</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div
              key={index}
              className="bg-[#141414] border border-white/10 p-6 space-y-4"
              data-testid={`stat-card-${stat.label.toLowerCase().replace(' ', '-')}`}
            >
              <div className="flex items-center justify-between">
                <p className="text-xs uppercase tracking-wider text-[#A3A3A3]">{stat.label}</p>
                <Icon size={20} style={{ color: stat.color }} />
              </div>
              <p className="text-3xl font-light text-white">{stat.value}</p>
            </div>
          );
        })}
      </div>

      <div className="bg-[#141414] border border-white/10 p-6">
        <h2 className="text-2xl font-light tracking-tighter text-white mb-6">Recent Orders</h2>
        {recentOrders.length === 0 ? (
          <p className="text-[#A3A3A3] text-center py-8">No orders yet</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full" data-testid="recent-orders-table">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-wider text-[#A3A3A3]">Order #</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-wider text-[#A3A3A3]">Customer</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-wider text-[#A3A3A3]">Amount</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-wider text-[#A3A3A3]">Status</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-wider text-[#A3A3A3]">Date</th>
                </tr>
              </thead>
              <tbody>
                {recentOrders.map((order) => (
                  <tr key={order.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                    <td className="py-4 px-4 text-[#D4AF37]">{order.order_number}</td>
                    <td className="py-4 px-4 text-white">{order.customer_name}</td>
                    <td className="py-4 px-4 text-white">₹{order.total_amount.toLocaleString()}</td>
                    <td className="py-4 px-4">
                      <span className={`px-3 py-1 text-xs uppercase tracking-wider ${
                        order.status === 'delivered' ? 'bg-[#34C759]/20 text-[#34C759]' :
                        order.status === 'pending' ? 'bg-[#FF9500]/20 text-[#FF9500]' :
                        'bg-[#007AFF]/20 text-[#007AFF]'
                      }`}>
                        {order.status}
                      </span>
                    </td>
                    <td className="py-4 px-4 text-[#A3A3A3]">
                      {new Date(order.created_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
